import { render, staticRenderFns } from "./CategoryInsights.vue?vue&type=template&id=51a9ca9f&scoped=true"
import script from "./CategoryInsights.vue?vue&type=script&lang=js"
export * from "./CategoryInsights.vue?vue&type=script&lang=js"
import style0 from "./CategoryInsights.vue?vue&type=style&index=0&id=51a9ca9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a9ca9f",
  null
  
)

export default component.exports